import { useMemo } from 'react'
import { getSignatureProvider } from './providers'
import type { SignatureProvider, SignatureProviderId } from './providers/types'

export function useSignatureProvider(id?: SignatureProviderId): SignatureProvider {
  return useMemo(() => getSignatureProvider(id), [id])
}
